<template>
  <div class="navigation shadow-lvl-2" :class="isOpen ? 'isOpen' : 'isClose'">
    <NavigationLogo
      :isOpen="isOpen"
      :logo="getNavigationData.logo"
      @change-open="toggleMenu"
    />
    <nav class="navigation--main">
      <ul>
        <NavigationItem
          v-for="(item, key) in getNavigationData.primary_button_area"
          :key="`${key}-${item.name}`"
          :item="item"
          :isOpen="isOpen"
        />
        <div class="navigation--main__extra">
          <NavigationExtraBlock
            :isOpen="isOpen"
            :extraBlock="getNavigationData.fast_action_button_area"
          />
        </div>
        <div class="navigation--main__bottom">
          <NavigationItem
            v-for="(item, key) in getNavigationData.service_button_area"
            :key="`${key}-${item.name}`"
            :item="item"
            :isOpen="isOpen"
          />
          <div
            class="navigation--main__profile"
            v-for="(item, key) in getNavigationData.profile_button_area"
            :key="key"
          >
            <NavigationProfile :isOpen="isOpen" :profile="item" />
          </div>
        </div>
      </ul>
    </nav>
  </div>
</template>
<script>
import { eventBus } from '@/bus';
import { store } from '@/store';
import NavigationExtraBlock from 'Elements/NavigationBar/NavigationExtraBlock';
import NavigationItem from 'Elements/NavigationBar/NavigationItem';
import NavigationLogo from 'Elements/NavigationBar/NavigationLogo';
import NavigationProfile from 'Elements/NavigationBar/NavigationProfile';

export default {
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    if (JSON.parse(localStorage.getItem('navMenu'))) {
      this.openMenu();
    }
  },
  mounted() {
    eventBus.$on('openMenu', this.openMenu);
    eventBus.$on('closeMenu', this.closeMenu);
    store.dispatch('navbar/getNavigationData');
  },
  methods: {
    openMenu() {
      if (this.isOpen) return;
      this.isOpen = true;
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
      localStorage.setItem('navMenu', this.isOpen);

      if (store.state.rightPanel.panelMode && window.innerWidth <= 1591) {
        store.commit('rightPanel/setParam', { name: 'panelMode', value: null });
        localStorage.setItem('rightPanelMode', null);
      }
    },
    closeMenu() {
      this.isOpen = false;
    },
    exitUser() {
      this.$store.dispatch('auth/exitUser');
    }
  },
  computed: {
    getNavigationData() {
      return store.state.navbar.navigationData;
    }
  },
  components: {
    NavigationLogo,
    NavigationItem,
    NavigationExtraBlock,
    NavigationProfile
  }
};
</script>
<style lang="scss" scoped>
.isOpen {
  width: 320px;
  min-width: 320px;
}

.isClose {
  width: 72px;
  min-width: 72px;
}

.navigation {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 28px 16px 28px 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  transition: all 0.2s;
  overflow: hidden;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: $grey40;
  background-color: $white;
  box-sizing: border-box;
  margin-right: 24px;

  &--main {
    height: 100%;
    ul {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
}

@media (min-height: 951px) {
  .navigation.isOpen {
    display: flex;

    .navigation--main {
      &__bottom {
        margin-top: auto;
      }
    }
  }
}

@media (max-height: 950px) {
  .isClose {
    & ::v-deep .profile {
      margin-bottom: 132px !important;
    }
  }

  .navigation.isOpen {
    display: flex;
    overflow-y: auto;

    .navigation--main {
      height: auto;
      padding-bottom: 42px;

      &__extra {
        order: 1;
        padding-bottom: 16px;
        background-color: $white;
        position: fixed;
        bottom: 0;
        display: flex;
        z-index: 12000;
        padding-top: 20px;
        background: linear-gradient(
          0deg,
          #ffffff 93.33%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
}

@media (max-width: 1312px) {
  .navigation {
    &.isOpen,
    &.isClose {
      position: absolute;
    }
  }
}

@media (max-height: 999px) {
  .navigation.isClose {
    display: flex;
    overflow-y: auto;

    .navigation--main {
      padding-bottom: 48px;

      &__extra {
        order: 1;
        padding-bottom: 16px;
        background-color: $white;
        position: fixed;
        bottom: 0;
        display: flex;
        z-index: 12000;
        padding-top: 20px;
        background: linear-gradient(
          0deg,
          #ffffff 93.33%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
}

@media (min-height: 1000px) {
  .navigation.isClose .navigation--main__bottom {
    margin-top: auto;
  }
}
</style>
